// @flow
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Tabs, Card, Table} from 'antd'
import RiskProfileComponent from '../view-trades/risk-profile'
import {ConvertTransactionToPositions} from '../../utils/TradeCalculations';
import {StyledContent} from './style'
const TabPane = Tabs.TabPane

const positionColumns = [
  {name: 'Instrument', title: 'Instrument', dataIndex: 'Instrument'},
  {name: 'OpenDate', title: 'Open Date', dataIndex: 'OpenDate'},
  {name: 'CloseDate', title: 'Close Date', dataIndex: 'CloseDate'},
  {name: 'Quantity', title: 'Qty', dataIndex: 'Quantity'},
  {name: 'AveragePrice', title: 'Avg Price', dataIndex: 'AveragePrice', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'Price', title: 'Price', dataIndex: 'Price'},
  {name: 'Delta', title: 'Delta', dataIndex: 'Delta', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'Gamma', title: 'Gamma', dataIndex: 'Gamma', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'Theta', title: 'Theta', dataIndex: 'Theta', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'Vega', title: 'Vega', dataIndex: 'Vega', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'ImpliedVolatility', title: 'IV', dataIndex: 'ImpliedVolatility', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'DaysToExpire', title: 'Days to Expire', dataIndex: 'DaysToExpire', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'PlOpen', title: 'P/L Open', dataIndex: 'PlOpen', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
  {name: 'PlClosed', title: 'P/L Closed', dataIndex: 'PlClosed', render: (text) => { return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')}},
]
class OwnPositions extends Component {
  
  state = {
    tradeId: this.props.tradeId,
    tradeName: '',
    activeTab: 'overview',
    tradeData: this.props.tradeData,
  }
  
  render() {
    const {tradeData} = this.state;
    const positions = ConvertTransactionToPositions(tradeData.transactions);
    return (
        <Row>
          <Col span={24}>
            <Tabs className="tabs">
              <TabPane tab='Overview' key='overview'>
                <h3>Positions: </h3>
                <Table
                  columns={positionColumns}
                  size={'small'}
                  dataSource={positions}
                  pagination={false}
                />
                <Row>
                  <Col span={24}>
                    <Card>
                      <RiskProfileComponent selectedTrade={tradeData} isFromPositions />
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  account: state.account.selectedAccount
})

export default connect(mapStateToProps, null)(OwnPositions)



// WEBPACK FOOTER //
// ./src/components/view-positions/TradeView.js